import { getLabelMessage } from '@gef-ui/localization/messages';

import isNumber from 'app/forms/validations/isNumber';
import isPolicyNo from 'app/forms/validations/isPolicyNo';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const MY_DOCUMENTS_FORM_NAME = 'productionControl-myDocuments';

const { policyNumber, controlStatus, client, documentType, centralConsent } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	policyNumber,
	controlStatus,
	client,
	documentType,
	centralConsent,
};

export default () => ({
	[FIELDS.policyNumber]: {
		deepPath: [FIELDS.policyNumber],
		validations: [isNumber({ customMessage: getLabelMessage('validation:allowedCharacters') }), isPolicyNo()],
	},
	[FIELDS.controlStatus]: {
		deepPath: [FIELDS.controlStatus],
		validations: [],
	},
	[FIELDS.centralConsent]: {
		deepPath: [FIELDS.centralConsent],
		validations: [],
	},
	[FIELDS.client]: {
		deepPath: [FIELDS.client],
		validations: [],
	},
	[FIELDS.documentType]: {
		deepPath: [FIELDS.documentType],
		validations: [],
	},
});
